export const EMAIL_REG_EXP = /^[A-Za-z0-9_]+[A-Za-z0-9_%-.+]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/

export const TargetFrame = {
  SameFrame: 'SameFrame',
  ParentFrame: 'ParentFrame',
  NewTab: 'NewTab',
}

export const ON_ACTION_CARD_SAVE_EVENT = 'onSaveData'
